import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-pe",
  "use": "icon-icon-pe-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"icon-icon-pe\">\n  <path fill=\"#D91023\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#fff\" d=\"M170.67 0h170.67v512H170.67z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol